module.exports = __webpack_public_path__ + "img/sg6.f125b385.png";